export const CONTROL_PANEL_VIEW_DATA_TYPE = "control-panel-view";